import { store } from './core/store/store';
import { AppPaths } from '@core/routes/routesPaths';
import { actionInterceptor } from '@core/store/middleware/actionsInterceptorMiddleware';
import { AppInit, INavLink, ConsentManager} from '@hwm/ui-lib';
import { MainMenu } from '@shared/components/MainMenu/MainMenu';
import UserDetails from '@shared/components/UserDetails';
import { styleConstants } from '@styles/constants';
import { lazy, useState } from 'react';
import 'react-h5-audio-player/lib/styles.css';
import 'uplot/dist/uPlot.min.css';
import { environment } from './environment';
import './index.css';
import theme from './styles/theme';
import { Preferences } from '@shared/components/Preferences';
import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { Provider } from 'react-redux';
import { userProfileReducer } from '@core/store/library-stores/user-profile';
import { Trans } from '@lingui/macro';

const LazyLayout = lazy(() => import('@shared/components/Layout'));
const consentTexts = {
  banner: {
    description: (
      <Trans>
        We use cookies to improve your experience. You can accept all cookies, reject non-essential cookies, or manage
        your preferences.
      </Trans>
    ),
    acceptAll: <Trans>Accept All</Trans>,
    rejectAll: <Trans>Reject All</Trans>,
    preferences: <Trans>Preferences</Trans>,
  },
  modal: {
    title: <Trans>Cookie Preferences</Trans>,
    analyticsLabel: <Trans>Analytics (Microsoft Clarity)</Trans>,
    analyticsDescription: (
      <Trans>
        Allows us to understand how visitors use our site to improve UX. No personal data is sold or shared outside our
        organization.
      </Trans>
    ),
    save: <Trans>Save Preferences</Trans>,
    cancel: <Trans>Cancel</Trans>,
  },
};

const AppComponent: React.FC = () => {
  const [links, setLinks] = useState<INavLink[]>([]);

  return (
    <I18nProvider i18n={i18n as any} forceRenderOnLocaleChange={false}>
      <Provider store={store}>
        <ConsentManager clarityId={environment.clarityId} texts={consentTexts}>
          {AppInit({
            LazyLayout: LazyLayout,
            actionInterceptor: actionInterceptor as any,
            applicationPaths: AppPaths,
            styleConstants: styleConstants,
            theme: theme,
            additionalConfig: {
              authority: environment.authority,
              clientId: environment.clientId,
              scope: environment.scope,
              silentLoginTimeout: environment.silentLoginTimeout,
            },
            initialLayoutProps: {
              appName: ['Perma', 'NET', ' Web'],
              customButtons: [<Preferences />, <UserDetails />, <MainMenu links={links} setLinks={setLinks} />],
              links: links,
              className: '',
              siderExpanded: false,
              sessionConfig: {
                sessionCookieDomain: environment.sessionCookieDomain,
                sessionCookieIsSecure: environment.sessionCookieSecure,
                sessionIdleTimeout: environment.sessionCookieIdleTimeout,
              },
              accountHierarchyReset: false,
            },
            redirectEmptyUrl: AppPaths.statistics.path.base.path,
            setOidcUser: (d) => store.dispatch(userProfileReducer.slice.actions.setOidcUser(d)),
          })}{' '}
        </ConsentManager>
      </Provider>
    </I18nProvider>
  );
};

export default AppComponent;
